import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import LayoutWithAccountCard from '../../layout/Layout/layout-account-card'
import { MENU_OPTIONS } from '../../layout/Layout/menu-options'
import MenuCard from '../../layout/Navigation/menu-card'
import { getMenuListSelector } from '../../selectors'

//const menuDetails =  MENU_OPTIONS.filter((ele) => ele.key === 'OTHER_SERVICES')[0].children
const subMenuDetails = MENU_OPTIONS.filter((ele) => ele.key === 'REQUESTS')[0].children
export default function Requests() {
  const history = useHistory()
  const menuConfig = useSelector(getMenuListSelector)['REQUESTS'] || {}

  return (
    <LayoutWithAccountCard breadCumKey="REQUEST">
      <Row>
      {Object.keys(menuConfig).length>0 && subMenuDetails.map((option, index) => (
          <>
            {menuConfig[option.key] &&
            <MenuCard
              handleMenuCallback={() => history.push(option.link)}
              icon={option.icon}
              name={option.title}
              description={option.desc}
              key={index}
            />
            }
          </>
        ))}
      </Row>
    </LayoutWithAccountCard>
  )
}
